var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-canvas" },
    _vm._l(_vm.data, function(value, key, idx) {
      return _c(
        "div",
        { key: idx, staticClass: "class_box", attrs: { title: key } },
        _vm._l(value, function(v, k, i) {
          return _c(
            "div",
            {
              key: i,
              staticClass: "canvas_box",
              attrs: { title: "key", title: key + ":" + k },
              on: {
                click: function($event) {
                  return _vm.click_dispatch($event, [key, k])
                }
              }
            },
            [_c("array-canvas", { key: i, attrs: { data: v } })],
            1
          )
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }